// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ChatController from "./chat_controller"
application.register("chat", ChatController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import MessageController from "./message_controller"
application.register("message", MessageController)

import QuickPickController from "./quick_pick_controller"
application.register("quick-pick", QuickPickController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import AutoSaveController from "./auto_save_controller"
application.register("auto-save", AutoSaveController)
